










































import axios from 'axios'
import Vue from 'vue'

const http = axios.create({
  auth: {
    password: 'test',
    username: 'flowfest-rest',
  },
  baseURL: '/api/processes/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  },
})

export default Vue.extend({
  // server/containers/evaluation_1.0.0-SNAPSHOT/
  data() {
    return {
      actuator_status: '',
      last_started_process: '',
      target_user: 'flowfest-rest',
      running_tasks: [],
      running_processes: [],
    }
  },
  methods: {
    testStore() {
      //this.$store.dispatch('getActualState')
      this.getActuatorStatus()
    },
    async getActuatorStatus() {
      return this.$store.getters.http
        .get(`/api/processes/actuator/health`)
        .then((response: any) => {
          if (response.data.status === 'UP') {
            this.actuator_status = 'Actuator is running'
          } else {
            this.actuator_status = 'Actuator is not available'
          }
        })
    },
    async createProcess() {
      return this.$store.getters.http.post(`/api/processes/process`).then((response: any) => {
        this.last_started_process = response.data
        this.getRunningTasks()
        this.getMyRunningProcesses()
      })
    },
    async getRunningTasks() {
      return this.$store.getters.http.get(`/api/processes/my-tasks`).then((response: any) => {
        this.running_tasks = []
        response.data.forEach(element => {
          this.running_tasks.push(element)
        })
      })
    },
    async getMyRunningProcesses() {
      return this.$store.getters.http.get(`/api/processes/my-processes`).then((response: any) => {
        this.running_processes = []
        response.data.forEach(element => {
          this.running_processes.push(element)
        })
      })
    },
    async finishTask(taskId, assignee) {
      return this.$store.getters.http
        .post(`/api/processes/taskcompleted?taskId=${taskId}`)
        .then((response: any) => {
          this.getRunningTasks()
          this.getMyRunningProcesses()
        })
    },
  },
  created() {
    this.getRunningTasks()
    this.getMyRunningProcesses()
  },
})
